// material
import { keyframes } from "@emotion/react"
import { Box, type BoxProps, Button } from "@mui/material"
import useCollapseDrawer from "hooks/useCollapseDrawer"
import { MessageCircle } from "lucide-react"
// ----------------------------------------------------------------------

export default function FeedbackNav({ sx }: BoxProps) {
  // Define the ping animation
  const pingAnimation = keyframes`
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.02);
      opacity: 0.9;
    }
  `
  const { isCollapse } = useCollapseDrawer()
  return (
    <Box sx={{ height: 40, marginBottom: 2, display: "flex", justifyContent: "center", ...sx }}>
      {!isCollapse ? (
        <Button
          startIcon={<MessageCircle size={20} aria-label="Feedback" />}
          type="submit"
          variant="contained"
          onClick={() => {
            window.open(
              "https://github.com/marketenterprise/the-lean-startup-hrme/issues",
              "_blank"
            )
          }}
          sx={{
            fontStyle: "italic",
            padding: "5px 20px",
            width: { xs: "95%", sm: "95%" },
            animation: `${pingAnimation} 2s infinite`
          }}
        >
          Tạo Issues! (v1.5.0)
        </Button>
      ) : (
        <Button
          type="submit"
          variant="contained"
          onClick={() => {
            window.open(
              "https://github.com/marketenterprise/the-lean-startup-hrme/issues",
              "_blank"
            )
          }}
          sx={{
            fontStyle: "italic",
            padding: "5px 2px",
            width: { xs: "50%", sm: "50%" },
            animation: `${pingAnimation} 2s infinite`
          }}
        >
          <MessageCircle size={20} aria-label="Feedback" />
        </Button>
      )}
    </Box>
  )
}
